import React, { Component } from 'react';
export default class Portofolio extends Component {
  render() {
    return (
      <section id="portfolio">
        <div className="row">
          <div className="twelve columns collapsed">
            <h1>Check Out Some of My Projects.</h1>
            {/* portfolio-wrapper */}
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">

              {/* Drinking Frenzy */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#hydration" title>
                    <img alt="" src="images/portfolio/hydration.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>DRINKING FRENZY</h5>
                        <p>Unity - Android/iOS - 2021</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Mizu Adventure */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#mizuiku" title>
                    <img alt="" src="images/portfolio/mizuiku.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>MIZU ADVENTURE</h5>
                        <p>Unity - Android/iOS - 2021</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Spot The Difference 3D */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#spot3d" title>
                    <img alt="" src="images/portfolio/spot3d.png" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>SPOT THE DIFFERENCE 3D</h5>
                        <p>Unity - Android/iOS - 2021</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* 8 Ball Now */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#8ball" title>
                    <img alt="" src="images/portfolio/8ball.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>8 BALL NOW</h5>
                        <p>Phaser.io - KaiOS - 2020</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Smart Meter */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#smart-meter" title>
                    <img alt="" src="images/portfolio/smart-meter.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>SMART METER</h5>
                        <p>Express.js/React.js/Unity - IoT Project - 2020</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Fullcourse */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#fullcourse" title>
                    <img alt="" src="images/portfolio/fullcourse.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>FULLCOURSE</h5>
                        <p>Phaser.io - Mobile - TBD</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Barber Talk */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#barber-talk" title>
                    <img alt="" src="images/portfolio/barber.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>BARBER TALK</h5>
                        <p>Unity - PC - 2020</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* Hello Distance */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#hello-distance" title>
                    <img alt="" src="images/portfolio/hello.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>HELLO DISTANCE</h5>
                        <p>Unity - Android - 2020</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

              {/* More */}
              <div className="columns portfolio-item">
                <div className="item-wrap">
                  <a href="#more" title>
                    <img alt="" src="images/portfolio/more.jpg" />
                    <div className="overlay">
                      <div className="portfolio-item-meta">
                        <h5>MORE</h5>
                        <p>Games</p>
                      </div>
                    </div>
                    <div className="link-icon"><i className="icon-plus" /></div>
                  </a>
                </div>
              </div>

            </div> {/* portfolio-wrapper end */}
          </div> {/* twelve columns end */}

          {/* MODAL POPUP------------------------------------------- */}

          {/* Barber Talk Modal */}
          <div id="barber-talk" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-barber.jpg" alt="" />
            <div className="description-box">
              <h4>BARBER TALK</h4>
              <p>Action arcade card game with barber theme, and multiple result reward.</p>
              <p>I initiated game design, and implemented whole game programming (card gameplay, high score system, result reward system).</p>
              <span className="categories"><i className="fa fa-tag" />Unity, PC, 2020</span>
            </div>
            <div className="link-box">
              <a href="https://vanillatiramisu.itch.io/barber-talk">Play</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>
          
          {/* Hello Distance Modal */}
          <div id="hello-distance" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-hello.png" alt="" />
            <div className="description-box">
              <h4>HELLO DISTANCE</h4>
              <p>Arcade obstacle game about spreading awareness for Covid-19 virus.</p>
              <p>I acted as project lead, and implemented whole game programming (obstacle AI system, power up system).</p>
              <span className="categories"><i className="fa fa-tag" />Unity, Android, 2020</span>
            </div>
            <div className="link-box">
              <a href="https://vanillatiramisu.itch.io/hello-distance">Play</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* Fullcourse Modal */}
          <div id="fullcourse" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-fullcourse.jpg" alt="" />
            <div className="description-box">
              <h4>FULLCOURSE</h4>
              <p>Ballpop competitive game with cooking theme.</p>
              <p>I implemented character selection mechanic, upgrade system, and game analytics for tracing player retention in mockup (game still in development).</p>
              <span className="categories"><i className="fa fa-tag" />Phaser.io, Mobile, TBD</span>
            </div>
            <div className="link-box">
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* More Modal */}
          <div id="more" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-more.jpg" alt="" />
            <div className="description-box">
              <h4>MORE</h4>
              <p>I often recreate various gameplay mechanic from various genre and customizing it. Check out some project that i create on my github page and my itch.io page</p>
              <span className="categories"><i className="fa fa-tag" />Games</span>
            </div>
            <div className="link-box">
              <a href="https://vanillatiramisu.itch.io/">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* Smart Meter Modal */}
          <div id="smart-meter" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/smart-meter.jpg" alt="" />
            <div className="description-box">
              <h4>SMART METER</h4>
              <p>Smart Meter architecture for data communication electricity meter.</p>
              <p>I designed, and implemented server, communication protocol, interface (web dashboard and mobile app), and integrating payment gateway service.</p>
              <span className="categories"><i className="fa fa-tag" />Express.js/React.js/Unity - IoT Project - 2020</span>
            </div>
            <div className="link-box">
              <a href="https://github.com/alijarasyidi/smart-meter">Details</a>
              <a href="https://www.youtube.com/watch?v=Zotn7p1M31s&feature=youtu.be" className="margin">Demo</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* 8 Ball Now Modal */}
          <div id="8ball" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-8ball.png" alt="" />
            <div className="description-box">
              <h4>8 BALL NOW</h4>
              <p>8 ball game with PvP and PvCOM campaign mode.</p>
              <p>I implemented core gameplay mechanic, created 8 ball game computer AI with 16 variation levels of difficulty, 
                optimize physics system used for targeted platform device.</p>
              <span className="categories"><i className="fa fa-tag" />Phaser.io, KaiOS, 2020</span>
            </div>
            <div className="link-box">
              <a href="https://youtu.be/aXUTleAm-XQ">Video</a>
              <a href="https://www.kaiostech.com/store/apps/?bundle_id=com.copiacorp.8ballnow" className="margin">Details</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* Spot The Difference 3D Modal */}
          <div id="spot3d" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/spot3d.jpg" alt="" />
            <div className="description-box">
              <h4>SPOT THE DIFFERENCE 3D</h4>
              <p>Puzzle game, spotting the differences between 2 environments.</p>
              <p>I created an interactive tutorial to significantly
                improve player engagement during the tutorial segment, and help initiated the use of Unity remote config.</p>
              <span className="categories"><i className="fa fa-tag" />Unity, Android/iOS, 2021</span>
            </div>
            <div className="link-box">
              <a href="https://youtu.be/sUET2MPH26E">Video</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* Mizu Adventure Modal */}
          <div id="mizuiku" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/mizuiku.jpg" alt="" />
            <div className="description-box">
              <h4>MIZU ADVENTURE</h4>
              <p>Edu game about water preservation with environment management and mini-games.</p>
              <p>I implemented most part of the game from gameplay,
                system, UI, analytic, camera, and tutorials.</p>
              <span className="categories"><i className="fa fa-tag" />Unity, Android/iOS, 2021</span>
            </div>
            <div className="link-box">
              <a href="https://youtu.be/NDwCqDgeIYc">Video</a>
              <a href="https://play.google.com/store/apps/details?id=com.suntorygaruda.Mizuiku" className="margin">Android</a>
              <a href="https://apps.apple.com/id/app/mizuadventure/id1553726025" className="margin">iOS</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

          {/* Drinking Frenzy Modal */}
          <div id="hydration" className="popup-modal mfp-hide">
            <img className="scale-with-grid" src="images/portfolio/modals/m-hydration.jpg" alt="" />
            <div className="description-box">
              <h4>DRINKING FRENZY</h4>
              <p>Drinking companion health app with nurturing feature of in-game plant pet-creature 
                that you can costumize, and AR feature to share your companion plant in real world environtment.
              </p>
              <p>I implemented most part of the game system: water hydration calculation system, shop system,
                customize system, reminder system, nurturing system, achievement system, daily challenge system, 
                plant creation system, troubleshoot AR functionality.
              </p>
              <span className="categories"><i className="fa fa-tag" />Unity, Android/iOS, 2021</span>
            </div>
            <div className="link-box">
              <a href="https://youtu.be/il1y4xupj14">Video</a>
              <a className="popup-modal-dismiss">Close</a>
            </div>
          </div>

        </div> {/* row End */}
      </section>
    )
  }
}